import { createElement, ElementType, FC } from "react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

type Props = {
  title: string;
  value?: string | number;
  icon: ElementType;
};

export const Metric: FC<Props> = ({ title, value, icon }) => {
  const glyph = createElement(icon, {
    className: "w-4 h-4",
    stroke: "var(--muted-foreground)",
    absoluteStrokeWidth: 1.33,
  });

  return (
    <Card className="flex-1 p-6 space-y-6">
      <CardHeader className="p-0">
        <CardTitle className="flex justify-between">
          <span>{title}</span>
          <span>{glyph}</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className=" font-medium text-2xl/tight">{value}</div>
      </CardContent>
    </Card>
  );
};
